/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Location/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import DataVaxiomSysOrganizationsLocationSelect from 'DesignSystem/DataVaxiomSysOrganizationsLocationSelect/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Location({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TracedCephs/Location"
  
}) {
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<DataVaxiomSysOrganizationsLocationSelect
  viewPath={`${viewPath}/DataVaxiomSysOrganizationsLocationSelect`}
 allowEmptyChoice={false}
 onChange={onChange}
/>
{children}
</React.Fragment>)
}